import { render, staticRenderFns } from "./FormTypesSubCategories.vue?vue&type=template&id=8d832f92"
import script from "./FormTypesSubCategories.vue?vue&type=script&lang=js"
export * from "./FormTypesSubCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports